<template>
  <div>
    <b-alert
      variant="primary"
      :show="show"
    >
      <div class="alert-body">
        <span> Equipos Contrato </span>
      </div>
    </b-alert>
    <b-card
      no-body
      class="mb-0 mt-1"
      title="Equipo"
      :show="!show"
    >
      <div class="m-2">
        <b-col md="12">
          <div class="demo-inline-spacing">
            <b-button
              v-if="!working"
              variant="primary"
              class="float-left"
              @click="search()"
            >
              <feather-icon icon="SearchIcon" />
              <span class="align-middle"> Consultar Equipos</span>
            </b-button>
            <b-button
              v-else
              variant="dark"
              class="float-left"
              disabled
            >
              <b-spinner small />
              Procesando...
            </b-button>
          </div>
        </b-col>

        <div
          class="m-2"
          md="12"
        >
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Ver</label>
              <v-select
                v-model="perPage"
                :dir="
                  $store.state.appConfig.isRTL ? 'rtl' : 'ltr'
                "
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>Lista</label>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <div
                class="d-flex align-items-center justify-content-end"
              >
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Buscar..."
                />
                <b-button
                  variant="primary"
                  hidden
                  @click="showModalOtNewEquipment"
                >
                  <span class="text-nowrap">
                    <feather-icon icon="PlusIcon" />
                    Solicitar Nuevo Equipo</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <div id="printEquipment">
          <b-table
            id="my-table"
            ref="refUserListTable"
            striped
            hover
            class="position-relative"
            :items="dataReport"
            responsive
            :fields="columns"
            :sort-by.sync="sortBy"
            show-empty
            :filter="searchQuery"
            empty-text="No existen registros para mostrar"
            :sort-desc.sync="isSortDirDesc"
            :per-page="perPage"
            :current-page="currentPage"
            small
            :busy="working"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
                <strong>Cargando...</strong>
              </div>
            </template>
            <template #cell(serial)="data">
              <b-media vertical-align="center">
                <template #aside>
                  <b-avatar
                    :id="`equipo-${data.item.equipo.idcontratoequipo}`"
                    size="30"
                    :variant="`light-${data.item.equipo.tipoprodclass}`"
                  >
                    <feather-icon
                      :icon="
                        data.item.equipo.tipoprodicono
                      "
                    />
                  </b-avatar>
                </template>

                <div
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ data.item.equipo.serial }}
                </div>
                <div>
                  <small class="text-muted">
                    {{ data.item.equipo.caja }}
                  </small>
                </div>
              </b-media>
            </template>

            <template #cell(estado)="data">
              <b-badge
                pill
                :variant="data.item.equipo.class"
              >
                {{ data.item.equipo.estado }}
              </b-badge>
            </template>

            <template #cell(equipo)="data">
              <span
                v-if="
                  data.item.equipo.equipo_olt != '' &&
                    data.item.equipo.equipo_olt != null
                "
                class="d-block text-nowrap"
              >
                {{ data.item.equipo.equipo_olt }}
              </span>
              <span
                v-if="
                  data.item.equipo.equipo_cas != '' &&
                    data.item.equipo.equipo_cas != null
                "
                class="d-block text-nowrap"
              >
                {{ data.item.equipo.equipo_cas }}
              </span>
            </template>

            <template #cell(actions)="data">
              <div v-if="data.item.equipo.is_iptv">
                <b-button
                  variant="info"
                  size="sm"
                  @click="showIptvCredentials(data.item.equipo)"
                >
                  <feather-icon icon="EyeIcon" />
                  <span class="align-middle"> TV+</span>
                </b-button>
              </div>
              <div v-else>
                <span class="text-muted">-</span>
              </div>
            </template>

            <template #cell(acciones)="">
              <div class="text-nowrap" />
            </template>
          </b-table>
        </div>

        <b-col cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            hide-goto-end-buttons
            :per-page="perPage"
            align="center"
            aria-controls="my-table"
            size="md"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          />
        </b-col>
      </div>
    </b-card>

    <!-- Modal para mostrar credenciales IPTV -->
    <b-modal
      ref="iptvCredentialsModal"
      title="Credenciales TV+"
      hide-footer
      centered
      size="md"
    >
      <div
        v-if="selectedIptvData"
      >
        <div class="text-center mb-3">
          <b-avatar
            :variant="`light-${selectedIptvData.tipoprodclass}`"
            size="50"
          >
            <feather-icon
              :icon="selectedIptvData.tipoprodicono"
              size="20"
            />
          </b-avatar>
          <h5 class="mb-0 mt-2">
            {{ selectedIptvData.serial }}
          </h5>
        </div>

        <div class="mb-3">
          <label class="form-label text-muted small mb-1">Usuario</label>
          <div class="input-group">
            <b-form-input
              :value="selectedIptvData.iptv_user || 'N/A'"
              readonly
              class="text-center font-weight-bold"
            />
            <div class="input-group-append">
              <b-button
                variant="outline-secondary"
                @click="copyToClipboard(selectedIptvData.iptv_user)"
              >
                <feather-icon
                  icon="CopyIcon"
                  size="16"
                />
              </b-button>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label class="form-label text-muted small mb-1">Contraseña</label>
          <div class="input-group">
            <b-form-input
              :value="selectedIptvData.iptv_password || 'N/A'"
              readonly
              class="text-center font-weight-bold"
            />
            <div class="input-group-append">
              <b-button
                variant="outline-secondary"
                @click="copyToClipboard(selectedIptvData.iptv_password)"
              >
                <feather-icon
                  icon="CopyIcon"
                  size="16"
                />
              </b-button>
            </div>
          </div>
        </div>

        <div class="text-center">
          <b-button
            variant="primary"
            @click="$refs.iptvCredentialsModal.hide()"
          >
            Cerrar
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BAlert,
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BFormInput,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BSpinner,
  BTable,
} from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import vSelect from "vue-select"
import toast from "../js/useNotification"
import useList from "./useList"

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BSpinner,
    BBadge,
    BPagination,
    BAvatar,
    BMedia,
    BAlert,
    vSelect,
    BFormInput,
    BModal,
  },
  directives: {
    Ripple,
  },
  props: {
    idcontrato: {
      type: Number,
      required: true,
    },
    data: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup() {
    const {
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
    } = useList()

    return {
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
    }
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      working: false,
      dataReport: [],
      selectedIptvData: null,
      columns: [
        { key: "serial", label: "serial", sortable: true },
        {
          key: "equipo.fecha",
          label: "Fecha",
          sortable: true,
          formatter: "dateFormat",
        },
        { key: "equipo.ubicacion", label: "ubicacion", sortable: true },
        {
          key: "equipo.paquetes",
          label: "paquete",
          sortable: true,
          formatter: "formatPlan",
          sortByFormatted: true,
        },
        {
          key: "estado",
          label: "estado",
          sortable: true,
          formatter: "formatStatus",
          sortByFormatted: true,
        },
        {
          key: "actions",
          label: "",
          sortable: false,
        },
      ],
      show: true,
      header: {},
    }
  },
  computed: {
    totalRows() {
      return this.dataReport.length
    },
  },
  created() {
    if (this.data != null) {
      this.header = {
        codigo: this.data.codigo,
        apenom: this.data.apenom,
      }
    }
    if (typeof this.idcontrato !== "undefined") {
      this.show = false
      this.search()
    }
  },
  methods: {
    newForm() {
      this.$router.go(0)
    },
    search() {
      this.working = true
      this.$http
        .get("/contrato-equipo", {
          params: {
            idcontrato: this.idcontrato,
            idusuario: this.userData.id,
          },
        })
        .then((response) => {
          this.working = false
          this.dataReport = response.data.data
        })
        .catch((error) => {
          this.working = false
          console.log(error)
          this.$swal({
            title: "Error",
            text: error.response.data.error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger",
            },
            buttonsStyling: false,
          })
        })
    },
    showModalOtNewEquipment() {
      this.$root.$emit("bv::show::modal", "modal-ot-new-equipment")
    },
    showIptvCredentials(equipo) {
      this.selectedIptvData = equipo
      this.$refs.iptvCredentialsModal.show()
    },
    copyToClipboard(text) {
      if (text && text !== 'N/A') {
        navigator.clipboard.writeText(text).then(() => {
          toast('CheckIcon', 'success', 'Copiado')
        }).catch(() => {
          toast('XIcon', 'error', 'No se pudo copiar el texto')
        })
      }
    },
    reload() {
      this.search()
    },
    formatPlan(value) {
      if (value.length > 0) {
        return `${value[0].nombre} - ${value[0].precio}`
      }

      return ""
    },
    dateFormat (string) {
      if (string == null) return ""

      return string.split("-").reverse().join("/")
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
